module.exports = __webpack_public_path__ + "static/img/measurement01.a4d0abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/measurements/measurement01.png
// module id = 14
// module chunks = 1